import { UtilitiesService } from '../services/utilities.service';

export class WorkOrderSummary {
    Date: Date;
    Id: string;
    Status: string;
    WorkOrderItem: string;
    WorkOrderNumber: number;
    Type: string;
    EstimatedRetailCost: number;
    ContractorName: string;
    PropertyId: string;

    get streetViewUrl(): string {
        return UtilitiesService.baseAPIUrl + 'address/' + this.PropertyId + '/StreetView';
    }
}
